import React, { useState, useRef, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { ClipLoader } from 'react-spinners';
import { IoMdArrowBack, IoMdHelpCircle } from 'react-icons/io';
import Swal from 'sweetalert2';
import { Col, Row, Radio } from 'antd';
import { useFormik } from 'formik';

import history from '~/services/history';

import * as actions from '~/store/modules/careLines/actions';
import { Input } from '~/components/Input';
import Breadcumbs from '~/components/Breadcumbs';
import ErrorField from '~/components/ErrorField';

import { LcAvcSchema } from '~/utils/schemas/lcAvcSchema';
import { onlyNumbers, scrollPageTo } from '~/helpers/generalFunctions';

import DadoFaltantes from '../components/DadosFaltantes';
import { RadioInput, RadioInputFlex } from '../components/RadioInput';

import { modalConfirm } from '../../LinhasDeCuidadoFormulario/dados/optionsModal';
import ButtonReset from '../components/ButtonReset';
import ButtonBack from '~/components/ButtonBack';

import {
  conveniosPaciente,
  tiposDeAvc,
  examesDeImagem,
  tempoInicioSintomas,
  chegadaEmergencia,
  atendimentoDuranteInternacao,
  tratamentoReperfusao,
  diagnosticoTriagemMedidas,
  medidasDeConforto,
  dadosSaida,
  recebeuAnticoagulante,
  covidAvc,
  saidaMotivo,
  causaObito,
  flutterAtrial,
  saidaEmergencia,
  seguimento,
  tromboliseIntravenosa,
  trombectomia,
} from './options';

import {
  PageTitle,
  BoxContent,
  Content,
  TitleSection,
  BoxInput,
  Label,
  BoxRadios,
  ButtonBox,
  BoxForm,
} from '../styles/style';
import ExceptionsForm from '../components/ExceptionsForm';
import { getTitleIndicador } from '../careLinesInfo';

const FichadeColetaAVC = ({ location }) => {
  const dispath = useDispatch();

  const { id } = location?.state || '';

  const { careLineData, loading, errorData } = useSelector(
    state => state.careLines
  );

  const firstFocus = useRef(null);

  const [dados, setDados] = useState(null);

  const [numeroPaciente, setNumeroPaciente] = useState('');

  // Limpar errors
  useEffect(() => {
    dispath(
      actions.avcFailure({
        errorData: null,
      })
    );
  }, []);

  useEffect(() => {
    if (location?.state?.id) {
      dispath(
        actions.avcGetRequest({
          id: location?.state?.id,
        })
      );
    }
  }, [location?.state]);

  const callHandleSubmit = () => {
    Swal.fire(modalConfirm).then(result => {
      if (result.value) {
        formik.handleSubmit();
      }
    });
  };

  useEffect(() => {
    scrollPageTo(75);
  }, []);

  useEffect(() => {
    if (id && careLineData) {
      setDados(careLineData);
    }
  }, [careLineData]);

  // Reset Button
  const [isLoaded, setIsloaded] = useState(false);

  const handleResetGroup = useCallback(group => {
    group.map(item => {
      formik.setFieldValue(`${item.name}`, null);
      exibeConteudoAdicional(`${item.name}`, null);
      logicaRamificacao(`${item.name}`, null);
    });
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsloaded(true);
    }, 2000);
  }, []);

  // End Reset Button

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      num_registro_avc: dados?.num_registro_avc?.toString() || null,
      sexo_avc: dados?.sexo_avc?.toString() || null,
      dn_avc: dados?.dn_avc?.toString() || null,
      convenio_avc: dados?.convenio_avc?.toString() || null,
      classificacao_avc: dados?.classificacao_avc?.toString() || null,
      ex_imagem_avc: dados?.ex_imagem_avc?.toString() || null,
      sintomas_data_avc: dados?.sintomas_data_avc?.toString() || null,
      sintomas_hora_avc: dados?.sintomas_hora_avc?.toString() || null,
      emergencia_data_avc: dados?.emergencia_data_avc?.toString() || null,
      emergencia_hora_avc: dados?.emergencia_hora_avc?.toString() || null,
      nihss_resultado_avc: dados?.nihss_resultado_avc?.toString() || null,
      local_avc_uni_vasc: dados?.local_avc_uni_vasc?.toString() || null,
      local_avc_emer_geral: dados?.local_avc_emer_geral?.toString() || null,
      local_avc_uti_neuro: dados?.local_avc_uti_neuro?.toString() || null,
      local_avc_uti_geral: dados?.local_avc_uti_geral?.toString() || null,
      local_avc_uni_avc: dados?.local_avc_uni_avc?.toString() || null,
      local_avc_enf_geral: dados?.local_avc_enf_geral?.toString() || null,
      reperfusao_avc_tiv: dados?.reperfusao_avc_tiv?.toString() || null,
      reperfusao_avc_tia: dados?.reperfusao_avc_tia?.toString() || null,
      reperfusao_avc_trombec: dados?.reperfusao_avc_trombec?.toString() || null,
      trombolise_data_avc: dados?.trombolise_data_avc?.toString() || null,
      trombolise_hora_avc: dados?.trombolise_hora_avc?.toString() || null,
      trombectomia_data_avc: dados?.trombectomia_data_avc?.toString() || null,
      trombectomia_hora_avc: dados?.trombectomia_hora_avc?.toString() || null,
      fa_avc: dados?.fa_avc?.toString() || null,
      disfagia_avc: dados?.disfagia_avc?.toString() || null,
      paliativos_avc: dados?.paliativos_avc?.toString() || null,
      antiagregante_avc: dados?.antiagregante_avc?.toString() || null,
      anticoagulante_avc: dados?.anticoagulante_avc?.toString() || null,
      covid_avc: dados?.covid_avc?.toString() || null,
      saida_motivo_avc: dados?.saida_motivo_avc?.toString() || null,
      obito_causa_avc: dados?.obito_causa_avc?.toString() || null,
      saida_data_avc: dados?.saida_data_avc?.toString() || null,
      saida_hora_avc: dados?.saida_hora_avc?.toString() || null,
      rankin_avc: dados?.rankin_avc?.toString() || null,
    },
    validationSchema: LcAvcSchema,

    onSubmit: async values => {
      if (id) {
        const payload = {
          ...dados,
          ...values,
        };

        /// limpa erros
        dispath(
          actions.avcFailure({
            errorData: null,
          })
        );

        return dispath(
          actions.avcUpdateRequest({
            data: payload,
            id: id,
            periodo: location?.state?.periodo,
          })
        );
      }
      dispath(
        actions.avcRequest({
          data: values,
          periodo: location?.state?.periodo,
        })
      );
    },
  });

  // Lógica de Ramificação:
  const [bloco1, setBloco1] = useState(false);
  const [bloco2, setBloco2] = useState(false);
  const [reperfusaoAvcTiv, setReperfusaoAvcTiv] = useState(false);
  const [reperfusaoAvcTrombec, setReperfusaoAvcTrombec] = useState(false);

  const limpaCamposBloco1 = () => {
    setBloco1(false);
    formik.setFieldValue('sintomas_data_avc', null);
    formik.setFieldValue('sintomas_hora_avc', null);
    formik.setFieldValue('emergencia_data_avc', null);
    formik.setFieldValue('emergencia_hora_avc', null);
    formik.setFieldValue('nihss_resultado_avc', null);
    formik.setFieldValue('local_avc_uni_vasc', null);
    formik.setFieldValue('local_avc_emer_geral', null);
    formik.setFieldValue('local_avc_uti_neuro', null);
    formik.setFieldValue('local_avc_uti_geral', null);
    formik.setFieldValue('local_avc_uni_avc', null);
    formik.setFieldValue('local_avc_enf_geral', null);
    formik.setFieldValue('disfagia_avc', null);
    formik.setFieldValue('paliativos_avc', null);
    formik.setFieldValue('saida_motivo_avc', null);
    formik.setFieldValue('obito_causa_avc', null);
    formik.setFieldValue('rankin_avc', null);
    formik.setFieldValue('saida_data_avc', null);
    formik.setFieldValue('saida_hora_avc', null);
  };

  const limpaCamposBloco2 = () => {
    setBloco2(false);
    formik.setFieldValue('reperfusao_avc_tiv', null);
    formik.setFieldValue('reperfusao_avc_tia', null);
    formik.setFieldValue('reperfusao_avc_trombec', null);
    formik.setFieldValue('trombolise_data_avc', null);
    formik.setFieldValue('trombolise_hora_avc', null);
    formik.setFieldValue('trombectomia_data_avc', null);
    formik.setFieldValue('trombectomia_hora_avc', null);
    formik.setFieldValue('fa_avc', null);
    formik.setFieldValue('antiagregante_avc', null);
    formik.setFieldValue('anticoagulante_avc', null);
  };

  const logicaRamificacao = useCallback(
    (name, value) => {
      if (name == 'classificacao_avc') {
        switch (value) {
          case '1':
            setBloco1(true);
            setBloco2(true);
            break;
          case '2':
            setBloco1(true);
            setBloco2(true);
            break;
          case '3':
            setBloco1(true);
            limpaCamposBloco2();
            break;
          case '4':
            limpaCamposBloco1();
            limpaCamposBloco2();
            break;
          case null:
            limpaCamposBloco1();
            limpaCamposBloco2();
            break;
          default:
            limpaCamposBloco1();
            limpaCamposBloco2();
        }
        formik.setFieldValue('classificacao_avc', value);
        // console.log('ultima linha', name, value);
      }
    },
    [formik]
  );

  const exibeConteudoAdicional = useCallback(
    (name, value) => {
      console.log('exibeConteudoAdicional :>> ', name, value);

      if (name == 'reperfusao_avc_tiv' && value == '1') {
        setReperfusaoAvcTiv(true);
      } else if (
        (name == 'reperfusao_avc_tiv' && value == '0') ||
        (name == 'reperfusao_avc_tiv' && value == null)
      ) {
        setReperfusaoAvcTiv(false);
        formik.setFieldValue('trombolise_data_avc', null);
        formik.setFieldValue('trombolise_hora_avc', null);
      }

      if (name == 'reperfusao_avc_trombec' && value == '1') {
        setReperfusaoAvcTrombec(true);
      } else if (
        (name == 'reperfusao_avc_trombec' && value == '0') ||
        (name == 'reperfusao_avc_trombec' && value == null)
      ) {
        setReperfusaoAvcTrombec(false);
        formik.setFieldValue('trombectomia_data_avc', null);
        formik.setFieldValue('trombectomia_hora_avc', null);
      }
      formik.setFieldValue(`${name}`, value);
    },
    [formik]
  );

  // useEffect(() => {
  //   if (formik.values.reperfusao_avc_tiv === '1') {
  //     setReperfusaoAvcTrombec(true);
  //   }
  // }, [formik.values.reperfusao_avc_tiv]);

  //  Lógica de ramificação ao editar:
  useEffect(() => {
    if (dados) {
      logicaRamificacao(
        'classificacao_avc',
        dados?.classificacao_avc?.toString()
      );
      exibeConteudoAdicional(
        'reperfusao_avc_tiv',
        dados?.reperfusao_avc_tiv?.toString()
      );

      exibeConteudoAdicional(
        'reperfusao_avc_trombec',
        dados?.reperfusao_avc_trombec?.toString()
      );
    }
  }, [dados]);

  useEffect(() => {
    const keyErrors = Object.keys(formik.errors);
    if (keyErrors.length > 0 && formik.isSubmitting) {
      setTimeout(() => {
        const errorElement = document.querySelector(`[name="${keyErrors[0]}"]`);
        if (errorElement)
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }, [formik.submitCount, formik.errors]);

  const getErrosPdf = useCallback(() => {
    const { indicador } = location.state;
    history.push({
      pathname: `/area-de-suporte`,
      state: {
        searchBy: `${getTitleIndicador(indicador)}`,
      },
    });
  }, []);

  return (
    <>
      <Breadcumbs
        path="acidente_vascular_cerebral"
        pathTitle="Adicionar Indicadores de Linhas de Cuidado / Acidente Vascular Cerebral (AVC)"
      />
      <PageTitle>
        <div>
          <ButtonBack />
          <span ref={firstFocus}>Ficha de coleta</span>
        </div>

        {errorData?.fields && isLoaded && (
          <button className="errorButton" type="button" onClick={getErrosPdf}>
            <IoMdHelpCircle size={16} color="#FFF" />
            Documentação de erros
          </button>
        )}
      </PageTitle>

      {loading ? (
        <BoxContent>
          <div className="boxSpin">
            <ClipLoader size={50} color="#74a50a" loading={loading} />
          </div>
        </BoxContent>
      ) : (
        <BoxContent>
          <div className="title">
            <h2>Preencha abaixo as informações:</h2>
          </div>

          {errorData?.fields && isLoaded && (
            <div className="BoxErros">
              <ExceptionsForm
                lc="acidente_vascular_cerebral"
                exceptions={errorData?.fields}
              />
            </div>
          )}

          <Content>
            <form onSubmit={formik.handleSubmit} method="post">
              {/* Linha de Cuidado, Competência e Dados Gerais */}
              <BoxForm>
                <Row>
                  <Col span={24}>
                    <BoxInput>
                      <Col span={12} className="item">
                        <TitleSection className="font-green">
                          {'>'} Linha de Cuidado
                        </TitleSection>
                        <input
                          type="text"
                          name="indicadorNome"
                          defaultValue={location?.state?.indicadorNome || ''}
                          disabled
                        />
                      </Col>
                      <Col span={12} className="item">
                        <TitleSection className="font-green">
                          {'>'} Competência
                        </TitleSection>
                        <input
                          type="text"
                          name="periodo"
                          defaultValue={location?.state?.periodo}
                          disabled
                        />
                      </Col>
                    </BoxInput>
                  </Col>
                </Row>

                <hr />

                <Row>
                  <Col span={24}>
                    <Row>
                      <Row>
                        <Col span={12}>
                          <TitleSection>
                            {'>'} Dados Gerais do paciente
                          </TitleSection>
                        </Col>
                      </Row>
                      <Col span={12} className="item">
                        <Input
                          name="num_registro_avc"
                          label="1) Número do registro"
                          type="text"
                          maxLength={5}
                          // placeholder="Número do registro"
                          value={
                            formik.values.num_registro_avc || numeroPaciente
                          }
                          hasError={
                            formik.errors.num_registro_avc &&
                            formik.touched.num_registro_avc
                              ? formik.errors.num_registro_avc
                              : ''
                          }
                          onChange={({ target }) => {
                            formik.setFieldValue(
                              'num_registro_avc',
                              onlyNumbers(target.value)
                            );
                          }}
                        />
                      </Col>

                      <Col span={12} className="item">
                        <Row>
                          <Col span={12}>
                            <Label>2{')'} Sexo</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[{ name: 'sexo_avc' }]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput>
                          <Col span={12}>
                            <BoxRadios
                              active={formik.values.sexo_avc === '1'}
                              style={{ maxWidth: '100%' }}
                            >
                              <Radio
                                name="sexo_avc"
                                value={formik.values.sexo_avc}
                                checked={formik.values.sexo_avc === '1'}
                                onChange={() =>
                                  formik.setFieldValue('sexo_avc', '1')
                                }
                              >
                                Feminino
                              </Radio>
                            </BoxRadios>
                          </Col>
                          <Col>
                            <BoxRadios
                              active={formik.values.sexo_avc === '0'}
                              style={{ maxWidth: '100%' }}
                            >
                              <Radio
                                name="sexo_avc"
                                value={formik.values.sexo_avc}
                                checked={formik.values.sexo_avc === '0'}
                                onChange={() =>
                                  formik.setFieldValue('sexo_avc', '0')
                                }
                              >
                                Masculino
                              </Radio>
                            </BoxRadios>
                          </Col>
                        </BoxInput>
                      </Col>
                    </Row>
                  </Col>

                  <Col span={24}>
                    <Row>
                      <Col span={12} className="item">
                        <DadoFaltantes
                          title="3) Data de nascimento"
                          name="dn_avc"
                          formik={formik}
                          hasError={
                            formik.errors.dn_avc && formik.submitCount > 0
                              ? formik.errors.dn_avc
                              : ''
                          }
                        />
                      </Col>

                      <Col span={12} className="item">
                        {conveniosPaciente.map(item => (
                          <RadioInputFlex
                            key={`${item.id}-${item.name}`}
                            item={item}
                            formik={formik}
                          />
                        ))}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </BoxForm>
              <hr />

              {/* Dados específicos da linha de cuidado */}
              <Row>
                <Col span={24}>
                  <Col span={12}>
                    <TitleSection>
                      {'>'} Dados da doença e do tratamento
                    </TitleSection>
                  </Col>
                  <BoxInput>
                    {tiposDeAvc.map(item => (
                      <Row>
                        <Row>
                          <Col span={12}>
                            <Label>{item.label}</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[...tiposDeAvc]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col span={12} key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    logicaRamificacao(item.name, opcao.value)
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>
                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </BoxInput>
                  <hr />

                  <BoxInput>
                    {examesDeImagem.map(item => (
                      <Row>
                        <Row>
                          <Col span={12}>
                            <Label>{item.label}</Label>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={[...examesDeImagem]}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <BoxInput key={item.id}>
                          {item.opcoes.map(opcao => (
                            <Col span={12} key={opcao.id}>
                              <BoxRadios
                                active={
                                  formik.values[item.name] === opcao.value
                                }
                                style={{ maxWidth: '100%' }}
                              >
                                <Radio
                                  name={item.name}
                                  value={formik.values[opcao.value]}
                                  checked={
                                    formik.values[item.name] === opcao.value
                                  }
                                  onChange={() =>
                                    formik.setFieldValue(
                                      `${item.name}`,
                                      opcao.value
                                    )
                                  }
                                >
                                  {opcao.descricao}
                                </Radio>
                              </BoxRadios>
                            </Col>
                          ))}
                        </BoxInput>

                        {formik.errors[item.name] && formik.submitCount > 0 ? (
                          <ErrorField message={formik.errors[item.name]} />
                        ) : null}
                      </Row>
                    ))}
                  </BoxInput>
                </Col>
              </Row>

              {/* Início Dados Adicionais */}
              {bloco1 && (
                <>
                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        <Row>
                          <h4>7{')'} Tempo de início dos sintomas</h4>
                        </Row>

                        <Row>
                          {tempoInicioSintomas.map(item => (
                            <Col span={12} className="item" key={item.id}>
                              <DadoFaltantes
                                title={item.label}
                                name={item.name}
                                formik={formik}
                                hasError={
                                  formik.errors[item.name] &&
                                  formik.submitCount > 0
                                    ? formik.errors[item.name]
                                    : ''
                                }
                              />
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    </Row>
                  </BoxForm>
                  <hr />

                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        <Row>
                          <h4>8{')'} Data e hora da chegada na emergência</h4>
                        </Row>
                        <Row>
                          {chegadaEmergencia.map(item => (
                            <Col span={12} className="item" key={item.id}>
                              <DadoFaltantes
                                title={item.label}
                                name={item.name}
                                formik={formik}
                                hasError={
                                  formik.errors[item.name] &&
                                  formik.submitCount > 0
                                    ? formik.errors[item.name]
                                    : ''
                                }
                              />
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    </Row>
                  </BoxForm>
                  <hr />

                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        <Row>
                          <Col span={12} className="item">
                            <BoxInput>
                              <Input
                                name="nihss_resultado_avc"
                                label="9) Pontuação da escala do NIHSS na admissão"
                                type="text"
                                // placeholder="Pontuação da escala do NIHSS na admissão"
                                value={formik.values.nihss_resultado_avc}
                                hasError={
                                  formik.errors.nihss_resultado_avc &&
                                  formik.touched.nihss_resultado_avc
                                    ? formik.errors.nihss_resultado_avc
                                    : ''
                                }
                                maxLength={2}
                                onChange={({ target }) => {
                                  formik.setFieldValue(
                                    'nihss_resultado_avc',
                                    onlyNumbers(target.value)
                                  );
                                }}
                              />
                            </BoxInput>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </BoxForm>

                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        <Row>
                          <Col span={12}>
                            <h4>
                              10{')'} Local de atendimento do paciente durante a
                              internação
                            </h4>
                          </Col>
                          <Col span={12}>
                            {isLoaded && (
                              <ButtonReset
                                resetGroup={atendimentoDuranteInternacao}
                                handleResetGroup={handleResetGroup}
                              />
                            )}
                          </Col>
                        </Row>
                        <Row>
                          {atendimentoDuranteInternacao.map(item => (
                            <Col span={12} className="item">
                              <div className="containerRadios">
                                <RadioInput
                                  key={`${item.id}-${item.name}`}
                                  item={item}
                                  formik={formik}
                                />
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </Col>
                    </Row>
                  </BoxForm>
                  <hr />

                  {bloco2 && (
                    <>
                      <BoxForm>
                        <Row>
                          <Col span={24}>
                            <Row>
                              <Col span={12}>
                                <h4>
                                  11{')'} Tratamentos de reperfusão realizados
                                </h4>
                              </Col>
                              <Col span={12}>
                                {isLoaded && (
                                  <ButtonReset
                                    resetGroup={[...tratamentoReperfusao]}
                                    handleResetGroup={handleResetGroup}
                                  />
                                )}
                              </Col>
                            </Row>
                            <Row>
                              {tratamentoReperfusao.map(item => (
                                <Row>
                                  <Label>{item.label}</Label>
                                  <BoxInput key={item.id}>
                                    {item.opcoes.map(opcao => (
                                      <Col key={opcao.id}>
                                        <BoxRadios
                                          active={
                                            formik.values[item.name] ===
                                            opcao.value
                                          }
                                          style={{ maxWidth: '100%' }}
                                        >
                                          <Radio
                                            name={item.name}
                                            value={formik.values[opcao.value]}
                                            checked={
                                              formik.values[item.name] ===
                                              opcao.value
                                            }
                                            onChange={() =>
                                              exibeConteudoAdicional(
                                                item.name,
                                                opcao.value
                                              )
                                            }
                                          >
                                            {opcao.descricao}
                                          </Radio>
                                        </BoxRadios>
                                      </Col>
                                    ))}
                                  </BoxInput>
                                  {formik.errors[item.name] &&
                                  formik.submitCount > 0 ? (
                                    <ErrorField
                                      message={formik.errors[item.name]}
                                    />
                                  ) : null}
                                </Row>
                              ))}
                            </Row>
                          </Col>
                        </Row>
                      </BoxForm>
                      {reperfusaoAvcTiv && (
                        <>
                          <BoxForm>
                            <Row>
                              <Col span={24}>
                                <Row>
                                  <h4>
                                    12{')'} Data e hora da realização da
                                    trombólise intravenosa
                                  </h4>
                                </Row>
                                <Row>
                                  {tromboliseIntravenosa.map(item => (
                                    <Col
                                      span={12}
                                      className="item"
                                      key={item.id}
                                    >
                                      <DadoFaltantes
                                        title={item.label}
                                        name={item.name}
                                        formik={formik}
                                        hasError={
                                          formik.errors[item.name] &&
                                          formik.submitCount > 0
                                            ? formik.errors[item.name]
                                            : ''
                                        }
                                      />
                                    </Col>
                                  ))}
                                </Row>
                              </Col>
                            </Row>
                          </BoxForm>
                          <hr />
                        </>
                      )}

                      {reperfusaoAvcTrombec && (
                        <>
                          <BoxForm>
                            <Row>
                              <Col span={24}>
                                <Row>
                                  <h4>
                                    13{')'} Data e hora da realização da
                                    trombectomia mecânica
                                  </h4>
                                </Row>
                                <Row>
                                  {trombectomia.map(item => (
                                    <Col
                                      span={12}
                                      className="item"
                                      key={item.id}
                                    >
                                      <DadoFaltantes
                                        title={item.label}
                                        name={item.name}
                                        formik={formik}
                                        hasError={
                                          formik.errors[item.name] &&
                                          formik.submitCount > 0
                                            ? formik.errors[item.name]
                                            : ''
                                        }
                                      />
                                    </Col>
                                  ))}
                                </Row>
                              </Col>
                            </Row>
                          </BoxForm>
                          <hr />
                        </>
                      )}
                      <BoxForm>
                        <Row>
                          <Col span={24}>
                            <Row>
                              {flutterAtrial.map(item => (
                                <Row>
                                  <Row>
                                    <Col span={12}>
                                      <Label>{item.label}</Label>
                                    </Col>
                                    <Col span={12}>
                                      {isLoaded && (
                                        <ButtonReset
                                          resetGroup={[...flutterAtrial]}
                                          handleResetGroup={handleResetGroup}
                                        />
                                      )}
                                    </Col>
                                  </Row>
                                  <BoxInput key={item.id}>
                                    {item.opcoes.map(opcao => (
                                      <Col key={opcao.id}>
                                        <BoxRadios
                                          active={
                                            formik.values[item.name] ===
                                            opcao.value
                                          }
                                          style={{ maxWidth: '100%' }}
                                        >
                                          <Radio
                                            name={item.name}
                                            value={formik.values[opcao.value]}
                                            checked={
                                              formik.values[item.name] ===
                                              opcao.value
                                            }
                                            onChange={() =>
                                              formik.setFieldValue(
                                                `${item.name}`,
                                                opcao.value
                                              )
                                            }
                                          >
                                            {opcao.descricao}
                                          </Radio>
                                        </BoxRadios>
                                      </Col>
                                    ))}
                                  </BoxInput>

                                  {formik.errors[item.name] &&
                                  formik.submitCount > 0 ? (
                                    <ErrorField
                                      message={formik.errors[item.name]}
                                    />
                                  ) : null}
                                </Row>
                              ))}
                            </Row>
                          </Col>
                        </Row>
                      </BoxForm>
                    </>
                  )}

                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        {diagnosticoTriagemMedidas.map(item => (
                          <Row>
                            <Row>
                              <Col span={12}>
                                <Label>{item.label}</Label>
                              </Col>
                              <Col span={12}>
                                {isLoaded && (
                                  <ButtonReset
                                    resetGroup={[...diagnosticoTriagemMedidas]}
                                    handleResetGroup={handleResetGroup}
                                  />
                                )}
                              </Col>
                            </Row>
                            <BoxInput key={item.id}>
                              {item.opcoes.map(opcao => (
                                <Col key={opcao.id}>
                                  <BoxRadios
                                    active={
                                      formik.values[item.name] === opcao.value
                                    }
                                    style={{ maxWidth: '100%' }}
                                  >
                                    <Radio
                                      name={item.name}
                                      value={formik.values[opcao.value]}
                                      checked={
                                        formik.values[item.name] === opcao.value
                                      }
                                      onChange={() =>
                                        formik.setFieldValue(
                                          `${item.name}`,
                                          opcao.value
                                        )
                                      }
                                    >
                                      {opcao.descricao}
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              ))}
                            </BoxInput>

                            {formik.errors[item.name] &&
                            formik.submitCount > 0 ? (
                              <ErrorField message={formik.errors[item.name]} />
                            ) : null}
                          </Row>
                        ))}
                      </Col>
                    </Row>
                  </BoxForm>
                  <hr />

                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        {medidasDeConforto.map(item => (
                          <Row>
                            <Row>
                              <Col span={12}>
                                <Label>{item.label}</Label>
                              </Col>
                              <Col span={12}>
                                {isLoaded && (
                                  <ButtonReset
                                    resetGroup={[...medidasDeConforto]}
                                    handleResetGroup={handleResetGroup}
                                  />
                                )}
                              </Col>
                            </Row>
                            <BoxInput key={item.id}>
                              {item.opcoes.map(opcao => (
                                <Col key={opcao.id}>
                                  <BoxRadios
                                    active={
                                      formik.values[item.name] === opcao.value
                                    }
                                    style={{ maxWidth: '100%' }}
                                  >
                                    <Radio
                                      name={item.name}
                                      value={formik.values[opcao.value]}
                                      checked={
                                        formik.values[item.name] === opcao.value
                                      }
                                      onChange={() =>
                                        formik.setFieldValue(
                                          `${item.name}`,
                                          opcao.value
                                        )
                                      }
                                    >
                                      {opcao.descricao}
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              ))}
                            </BoxInput>

                            {formik.errors[item.name] &&
                            formik.submitCount > 0 ? (
                              <ErrorField message={formik.errors[item.name]} />
                            ) : null}
                          </Row>
                        ))}
                      </Col>
                    </Row>
                  </BoxForm>
                  <hr />
                </>
              )}

              <Row>
                <Col span={12}>
                  <TitleSection>{'>'} Dados da Saída</TitleSection>
                </Col>
              </Row>

              {bloco1 && (
                <>
                  {bloco2 && (
                    <>
                      <BoxForm>
                        <Row>
                          <Col span={24}>
                            {dadosSaida.map(item => (
                              <Row>
                                <Row>
                                  <Col span={12}>
                                    <Label>{item.label}</Label>
                                  </Col>
                                  <Col span={12}>
                                    {isLoaded && (
                                      <ButtonReset
                                        resetGroup={dadosSaida}
                                        handleResetGroup={handleResetGroup}
                                      />
                                    )}
                                  </Col>
                                </Row>
                                <BoxInput key={item.id}>
                                  {item.opcoes.map(opcao => (
                                    <Col key={opcao.id}>
                                      <BoxRadios
                                        active={
                                          formik.values[item.name] ===
                                          opcao.value
                                        }
                                        style={{ maxWidth: '100%' }}
                                      >
                                        <Radio
                                          name={item.name}
                                          value={formik.values[opcao.value]}
                                          checked={
                                            formik.values[item.name] ===
                                            opcao.value
                                          }
                                          onChange={() =>
                                            formik.setFieldValue(
                                              `${item.name}`,
                                              opcao.value
                                            )
                                          }
                                        >
                                          {opcao.descricao}
                                        </Radio>
                                      </BoxRadios>
                                    </Col>
                                  ))}
                                </BoxInput>

                                {formik.errors[item.name] &&
                                formik.submitCount > 0 ? (
                                  <ErrorField
                                    message={formik.errors[item.name]}
                                  />
                                ) : null}
                              </Row>
                            ))}
                          </Col>
                        </Row>
                      </BoxForm>
                      <hr />
                      <BoxForm>
                        <Row>
                          <Col span={24}>
                            {recebeuAnticoagulante.map(item => (
                              <Row>
                                <Row>
                                  <Col span={12}>
                                    <Label>{item.label}</Label>
                                  </Col>
                                  <Col span={12}>
                                    {isLoaded && (
                                      <ButtonReset
                                        resetGroup={recebeuAnticoagulante}
                                        handleResetGroup={handleResetGroup}
                                      />
                                    )}
                                  </Col>
                                </Row>
                                <BoxInput key={item.id}>
                                  {item.opcoes.map(opcao => (
                                    <Col key={opcao.id}>
                                      <BoxRadios
                                        active={
                                          formik.values[item.name] ===
                                          opcao.value
                                        }
                                        style={{ maxWidth: '100%' }}
                                      >
                                        <Radio
                                          name={item.name}
                                          value={formik.values[opcao.value]}
                                          checked={
                                            formik.values[item.name] ===
                                            opcao.value
                                          }
                                          onChange={() =>
                                            formik.setFieldValue(
                                              `${item.name}`,
                                              opcao.value
                                            )
                                          }
                                        >
                                          {opcao.descricao}
                                        </Radio>
                                      </BoxRadios>
                                    </Col>
                                  ))}
                                </BoxInput>

                                {formik.errors[item.name] &&
                                formik.submitCount > 0 ? (
                                  <ErrorField
                                    message={formik.errors[item.name]}
                                  />
                                ) : null}
                              </Row>
                            ))}
                          </Col>
                        </Row>
                      </BoxForm>
                      <hr />
                    </>
                  )}
                </>
              )}

              <Row>
                <Col span={24}>
                  {covidAvc.map(item => (
                    <Row>
                      <Row>
                        <Col span={12}>
                          <Label>{item.label}</Label>
                        </Col>
                        <Col span={12}>
                          {isLoaded && (
                            <ButtonReset
                              resetGroup={covidAvc}
                              handleResetGroup={handleResetGroup}
                            />
                          )}
                        </Col>
                      </Row>
                      <BoxInput key={item.id}>
                        {item.opcoes.map(opcao => (
                          <Col key={opcao.id}>
                            <BoxRadios
                              active={formik.values[item.name] === opcao.value}
                              style={{ maxWidth: '100%' }}
                            >
                              <Radio
                                name={item.name}
                                value={formik.values[opcao.value]}
                                checked={
                                  formik.values[item.name] === opcao.value
                                }
                                onChange={() =>
                                  formik.setFieldValue(
                                    `${item.name}`,
                                    opcao.value
                                  )
                                }
                              >
                                {opcao.descricao}
                              </Radio>
                            </BoxRadios>
                          </Col>
                        ))}
                      </BoxInput>

                      {formik.errors[item.name] && formik.submitCount > 0 ? (
                        <ErrorField message={formik.errors[item.name]} />
                      ) : null}
                    </Row>
                  ))}
                </Col>
              </Row>
              {bloco1 && (
                <>
                  <BoxForm>
                    <Row>
                      <Col span={24}>
                        {saidaMotivo.map(item => (
                          <Row>
                            <Row>
                              <Col span={12}>
                                <Label>{item.label}</Label>
                              </Col>
                              <Col span={12}>
                                {isLoaded && (
                                  <ButtonReset
                                    resetGroup={saidaMotivo}
                                    handleResetGroup={handleResetGroup}
                                  />
                                )}
                              </Col>
                            </Row>
                            <BoxInput key={item.id}>
                              {item.opcoes.map(opcao => (
                                <Col span={12} key={opcao.id}>
                                  <BoxRadios
                                    active={
                                      formik.values[item.name] === opcao.value
                                    }
                                    style={{ maxWidth: '100%' }}
                                  >
                                    <Radio
                                      name={item.name}
                                      value={formik.values[opcao.value]}
                                      checked={
                                        formik.values[item.name] === opcao.value
                                      }
                                      onChange={() =>
                                        formik.setFieldValue(
                                          `${item.name}`,
                                          opcao.value
                                        )
                                      }
                                    >
                                      {opcao.descricao}
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              ))}
                            </BoxInput>

                            {formik.errors[item.name] &&
                            formik.submitCount > 0 ? (
                              <ErrorField message={formik.errors[item.name]} />
                            ) : null}
                          </Row>
                        ))}
                      </Col>
                    </Row>

                    <Row>
                      <Col span={24}>
                        {causaObito.map(item => (
                          <Row>
                            <Row>
                              <Col span={12}>
                                <Label>{item.label}</Label>
                              </Col>
                              <Col span={12}>
                                {isLoaded && (
                                  <ButtonReset
                                    resetGroup={causaObito}
                                    handleResetGroup={handleResetGroup}
                                  />
                                )}
                              </Col>
                            </Row>
                            <BoxInput key={item.id}>
                              {item.opcoes.map(opcao => (
                                <Col span={12} key={opcao.id}>
                                  <BoxRadios
                                    active={
                                      formik.values[item.name] === opcao.value
                                    }
                                    style={{ maxWidth: '100%' }}
                                  >
                                    <Radio
                                      name={item.name}
                                      value={formik.values[opcao.value]}
                                      checked={
                                        formik.values[item.name] === opcao.value
                                      }
                                      onChange={() =>
                                        formik.setFieldValue(
                                          `${item.name}`,
                                          opcao.value
                                        )
                                      }
                                    >
                                      {opcao.descricao}
                                    </Radio>
                                  </BoxRadios>
                                </Col>
                              ))}
                            </BoxInput>

                            {formik.errors[item.name] &&
                            formik.submitCount > 0 ? (
                              <ErrorField message={formik.errors[item.name]} />
                            ) : null}
                          </Row>
                        ))}
                      </Col>
                    </Row>

                    <Row>
                      <h4>22{')'} Data e hora da saída</h4>
                    </Row>
                    <Row>
                      {saidaEmergencia.map(item => (
                        <Col span={12} className="item" key={item.id}>
                          <DadoFaltantes
                            title={item.label}
                            name={item.name}
                            formik={formik}
                            hasError={
                              formik.errors[item.name] && formik.submitCount > 0
                                ? formik.errors[item.name]
                                : ''
                            }
                          />
                        </Col>
                      ))}
                    </Row>
                  </BoxForm>
                  <hr />

                  <BoxForm>
                    <Row>
                      <Col span={12}>
                        <TitleSection>{'>'} Seguimento</TitleSection>
                      </Col>
                      <Col span={12}>
                        {isLoaded && (
                          <ButtonReset
                            resetGroup={seguimento}
                            handleResetGroup={handleResetGroup}
                          />
                        )}
                      </Col>
                    </Row>
                    <Row>
                      {seguimento.map(item => (
                        <Row>
                          <Label>{item.label}</Label>
                          <BoxInput key={item.id}>
                            {item.opcoes.map(opcao => (
                              <Col span={12} key={opcao.id}>
                                <BoxRadios
                                  active={
                                    formik.values[item.name] === opcao.value
                                  }
                                  style={{ maxWidth: '100%' }}
                                >
                                  <Radio
                                    name={item.name}
                                    value={formik.values[opcao.value]}
                                    checked={
                                      formik.values[item.name] === opcao.value
                                    }
                                    onChange={() =>
                                      formik.setFieldValue(
                                        `${item.name}`,
                                        opcao.value
                                      )
                                    }
                                  >
                                    {opcao.descricao}
                                  </Radio>
                                </BoxRadios>
                              </Col>
                            ))}
                          </BoxInput>

                          {formik.errors[item.name] &&
                          formik.submitCount > 0 ? (
                            <ErrorField message={formik.errors[item.name]} />
                          ) : null}
                        </Row>
                      ))}
                    </Row>
                  </BoxForm>
                  <hr />
                </>
              )}

              <ButtonBox>
                <button type="button" onClick={callHandleSubmit}>
                  {loading ? 'Enviando dados...' : 'Salvar'}
                </button>
              </ButtonBox>
            </form>
          </Content>
        </BoxContent>
      )}
    </>
  );
};

FichadeColetaAVC.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      indicador: PropTypes.string,
      indicadorNome: PropTypes.string,
      periodo: PropTypes.string,
    }),
  }).isRequired,
};

export default FichadeColetaAVC;
